<template lang="pug">
    .carousel-all-ms

        section.md-section.md-section-top(style="background-color:#f7f7f7;padding-top:0;")
            .container(style="padding-bottom: 200px;")
                .row
                    .col-md-12.col-lg-12.offset-0.offset-sm-0
                        .iconbox
                            div
                                h2.iconbox__title.iconbox__title-sub.set-sub-home(v-html="lenguageSelected.subHome", style="text-transform: inherit!important;")
                                .iconbox__description.iconbox__title-desc(style="color: #7d7d7d")
                                    | {{ lenguageSelected.subHomeDesc }}
                                    section.md-section(style="background-color:#f7f7f7;padding:0;")
                

            .container(style="padding-bottom: 100px")
                .textbox-group
                    .row(style="padding: 50px 0px;")
                        h3(style="width: 100%; color: #073a74")  {{ lenguageSelected.content.title }}
                    .row(style=" display: flex;justify-content:center;")
                        PmHomeCard(:image="card0", :link="lenguageSelected.homeCard1.link", :lenguage="lenguageSelected.homeCard1",href="https://www.who.int/", target="_blank")
                        PmHomeCard(:image="card1", :link="lenguageSelected.homeCard2.link", :lenguage="lenguageSelected.homeCard2",href="https://www.icnirp.org/", target="_blank")
                    .row(style=" display: flex;justify-content:center;")
                        PmHomeCard(:image="card2", :link="lenguageSelected.homeCard3.link", :lenguage="lenguageSelected.homeCard3",href="https://www.itu.int/es/Pages/default.aspx", target="_blank")  
                        PmHomeCard(:image="card3", :link="lenguageSelected.homeCard4.link", :lenguage="lenguageSelected.homeCard4",href="https://www.mwfai.org/", target="_blank")  

        
</template>

<script>
import carousel from 'vue-owl-carousel'

import card0 from '@img/newsenviromental/zyro-omsig.png'
import card1 from '@img/newsenviromental/zyro-icnirp.png'
import card2 from '@img/newsenviromental/zyro-ituwrc.png'
import card3 from '@img/newsenviromental/zyro-mwf.png'


import PmHomeSlider from '@components/atoms/PmHomeSlider.vue'
import PmHomeCard from '@components/atoms/PmHomeCard.vue'
import PmHomeService from '@components/atoms/PmHomeService.vue'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    mounted: function(){
    let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },
    components: { 
        carousel, PmHomeSlider, PmHomeCard, PmHomeService
    },
    methods: {
        changeCountry: function(data){
            this.$data.selectedCountry = data
            console.log(this.$data.selectedCountry)
        }
    },
    data: function(){
        return {

            card0: card0,
            card1: card1,
            card2: card2,
            card3: card3,

            lenguage: 'ES',
            
            lenguageEN: {
                homeCard1: {link: 'https://www.who.int/',title: 'Wordl Health Organization', content:'The World Health Organization (WHO) in Spanish, is the body of the United Nations Organization (UN) specialized in political efforts for prevention, promotion and intervention at the global level of health, defined in its Constitution as a state of complete physical, mental and social well-being.'},
                homeCard2: {link: 'https://www.icnirp.org/',title: 'I C N I R P', content: 'The International Commission on Non-Ionizing Radiation Protection (ICNIRP) is an international commission specializing in non-ionizing radiation protection. The organizations activities include determining exposure limits for electromagnetic fields used by devices such as cell phones.'},
                homeCard3: {link: 'https://www.itu.int/es/Pages/default.aspx',title: 'U I T', content: 'The International Telecommunication Union (ITU) is the specialized agency in telecommunications of the United Nations (UN), in charge of regulating telecommunications at the international level between the different administrations and operating companies. Its headquarters are located in the city of Geneva (Switzerland).'},
                homeCard4: {link: 'https://www.mwfai.org/',title: 'Mobile & Wireless Forum', content: 'Welcome to the Mobile & Wireless Forum ,We are an international association of companies with an interest in mobile and wireless communications including the evolution to 5G and the Internet of Things.'},

                content: {
                    title: 'Ecuador Environmental News',}
            },
            lenguageES: {
                homeCard1: {link: 'https://www.who.int/',title: 'Organizacion Mundial de la Salud', content: 'La Organización Mundial de la Salud (OMS) en español, es el organismo de la Organización de las Naciones Unidas (ONU) especializado en gestiones políticas de prevención, promoción e intervención a nivel mundial de la salud, definida en su Constitución como un estado de completo bienestar físico, mental y social.'},
                homeCard2: {link: 'https://www.icnirp.org/',title: 'I C N I R P', content: 'La Comisión Internacional de Protección de Radiación no Ionizante (ICNIRP) es una comisión internacional especializada en protección de radiación no ionizante. Las actividades de la organización incluyen determinar límites de exposición para campos electromagnéticos utilizados por dispositivos como teléfonos celulares.'},
                homeCard3: {link: 'https://www.itu.int/es/Pages/default.aspx',title: 'U I T', content: 'La Unión Internacional de Telecomunicaciones (UIT) es el organismo especializado en telecomunicaciones de la Organización de las Naciones Unidas (ONU), encargado de regular las telecomunicaciones a nivel internacional entre las distintas administraciones y empresas operadoras. Su sede se encuentra en la ciudad de Ginebra (Suiza).'},
                homeCard4: {link: 'https://www.mwfai.org/',title: 'Mobile & Wireless Forum', content: 'Bienvenido al Foro Móvil e Inalámbrico.Somos una asociación internacional de empresas interesadas en las comunicaciones móviles e inalámbricas, incluida la evolución hacia 5G e Internet de las cosas.'},

                content: {
                    title: 'Ecuador Noticias Ambientales',}
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    }
}
</script>

<style lang="scss" scoped>
    .carousel-all-ms{
        margin-top: 105px;
    }
</style>




// WEBPACK FOOTER //
// src/components/organisms/PmNewsEnvironmental.vue